/* eslint-disable */

import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';

import {
  IValidatedUnsignedKnmByPlan,
  IValidatedUnsignedKnmError,
} from 'APIPackage/KnmModule/interfaces/IValidatedUnsignedKnmByPlan';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { KnmStatusesEnum } from 'KnmPackage/MainModule/enums/KnmStatusesEnum';
import { Row } from 'UIPackage/FormModule/components/Row';
import { ROUTE_KNM } from 'CorePackage/MainModule/routes/routes';

import { getValidatedUnsignedKnmByPlan } from '../selectors/planSelectors';
import styles from './ValidatedUnsignedKnmByPlan.module.scss';

interface IValidatedUnsignedKnmByPlanProps {
  handleCloseSignModal: () => void;
  handleSignPlan: (errors: IValidatedUnsignedKnmError[]) => void;
  isFIOandJobTitle_4_1_4: boolean;
  isEnableKnoValidationSigning: boolean;
}

interface IValidatedUnsignedKnmByPlanStoreProps {
  validatedUnsignedKnmByPlan: IValidatedUnsignedKnmByPlan | undefined;
}

const ValidatedUnsignedKnmByPlanWithoutStore = ({
  validatedUnsignedKnmByPlan,
  handleCloseSignModal,
  handleSignPlan,
  isFIOandJobTitle_4_1_4,
  isEnableKnoValidationSigning,
}: IValidatedUnsignedKnmByPlanProps & IValidatedUnsignedKnmByPlanStoreProps) => {
  useEffect(() => {
    if (validatedUnsignedKnmByPlan && validatedUnsignedKnmByPlan.status === KnmStatusesEnum.SUCCEEDED) {
      if (isFIOandJobTitle_4_1_4 && !validatedUnsignedKnmByPlan.signerFullNameValid) {
        return;
      }
      if (!validatedUnsignedKnmByPlan.organizationNameValid && isEnableKnoValidationSigning) {
        return;
      }
      if (validatedUnsignedKnmByPlan.errors && validatedUnsignedKnmByPlan.errors.length > 0) {
        handleSignPlan(validatedUnsignedKnmByPlan.errors || []);
      } else if (!validatedUnsignedKnmByPlan.organizationNameValid) {
        handleSignPlan(validatedUnsignedKnmByPlan.errors || []);
        handleCloseSignModal();
      } else {
        handleSignPlan([]);
        handleCloseSignModal();
      }
    }
  }, [validatedUnsignedKnmByPlan]);

  if (!validatedUnsignedKnmByPlan || validatedUnsignedKnmByPlan.status !== KnmStatusesEnum.SUCCEEDED) {
    return null;
  }

  return (
    <div className={styles.Wrapper}>
      {!isFIOandJobTitle_4_1_4 && validatedUnsignedKnmByPlan.errors && validatedUnsignedKnmByPlan.errors.length > 0 && (
        <>
          <Row>
            <div className={styles.InfoBlockError}>
              <span className={styles.InfoIconError}></span>
              <span className={styles.InfoTextError}>
                Следующие паспорта КНМ в составе плана не будут подписаны. ФИО в сертификате ЭП не соответствует ФИО
                должностного лица, подписавшего решение о проведении КНМ
              </span>
            </div>
          </Row>
          <div className={styles.LinkWrapper}>
            {validatedUnsignedKnmByPlan.errors.map((error, index) => {
              return (
                <span key={index} className={styles.LinkRow}>
                  {index + 1}.
                  <Link className={styles.Link} to={ROUTE_KNM(error.id)} target="_blank" rel="noopener noreferrer">
                    {error.erpId}
                  </Link>
                  {error.subjectName}
                </span>
              );
            })}
          </div>
        </>
      )}
      {isFIOandJobTitle_4_1_4 && !validatedUnsignedKnmByPlan.signerFullNameValid && (
        <Row>
          <div className={styles.InfoBlockError}>
            <span className={styles.InfoIconError}></span>
            <span className={styles.InfoTextError}>
              ФИО в сертификате ЭП не соответствует ФИО ответственного лица, утверждающего план
            </span>
          </div>
        </Row>
      )}
      {!validatedUnsignedKnmByPlan.organizationNameValid && (
        <Row>
          <div className={isEnableKnoValidationSigning ? styles.InfoBlockError : styles.InfoBlock}>
            <span className={isEnableKnoValidationSigning ? styles.InfoIconError : styles.InfoIcon}></span>
            <span className={isEnableKnoValidationSigning ? styles.InfoTextError : styles.InfoText}>
              Организация{' '}
              {validatedUnsignedKnmByPlan?.organizationName?.length
                ? `‘${validatedUnsignedKnmByPlan.organizationName}’ `
                : ' '}
              в сертификате ЭП не соответствует полному наименованию КНО в ЕРВК.
            </span>
          </div>
        </Row>
      )}
    </div>
  );
};

const mapStateToProps = (state: IRootState) => ({
  validatedUnsignedKnmByPlan: getValidatedUnsignedKnmByPlan(state),
});

export const ValidatedUnsignedKnmByPlan = connect(mapStateToProps)(ValidatedUnsignedKnmByPlanWithoutStore);
